<script setup>
import {ref} from "vue";
import PartnershipsGrid from "@/components/partnerships/PartnershipsGrid.vue";
import PrimaryButton from "@/components/ui/PrimaryButton.vue";
import marketSubSectorsService from "@/services/market-sub-sectors.service";

const showModal = ref(false);
const subsectorId = ref(0);
const partnershipsGrid = ref(null);
const loading = ref(false);

async function populatePartnerships(model) {
    loading.value = true;
    await marketSubSectorsService.populatePartnerships(subsectorId.value, model);

    loading.value = false;
    partnershipsGrid.value?.reset();
}

function open(id) {
    subsectorId.value = id;
    showModal.value = true;
    loading.value = false;
}

defineExpose({
    open
});
</script>

<template>
    <b-modal v-model="showModal" title="Partnerships" modal-class="modal-w-xxl">
        <div style="max-height: 600px; overflow: auto;">
            <PartnershipsGrid
                ref="partnershipsGrid"
                for-modal
                :subsector-id="subsectorId"
            />
        </div>

        <template #modal-footer>
            <PrimaryButton
                caption="Populate partnerships with GPT"
                :loading="loading"
                loading-caption="Loading..."
                @click="populatePartnerships('gpt-4o')"
            />

            <PrimaryButton
                class="ml-3"
                caption="Populate partnerships with PPX"
                :loading="loading"
                loading-caption="Loading..."
                @click="populatePartnerships('perplexity')"
            />
        </template>
    </b-modal>
</template>

<style scoped>

</style>
